module.exports = __webpack_public_path__ + "static/media/cinech.1080a756.png";